import React, { useEffect, useState } from "react";
import ic_checked from "../img/ic_checked.png";
import ic_unchecked from "../img/ic_unchecked.png";
import axios from "axios";
import ic_search_tire_loader from "../img/ic_tire_loader.png";

function Technician_list_popup(props) {

    const [isCallingApiGetTechnicianList, setIsCallingApiGetTechnicianList] = useState(false);

    const [arrayOfTechnicians, setArrayOfTechnicians] = useState(null);

    const { clickedOnCloseButton, clickedOnSaveButton } = props;


    const changeToggleStatusOfTechnicianList = (indexFromClick) => {

        console.log("indexFromClick is", indexFromClick)

        let newArray = arrayOfTechnicians.map((item, index) => {
            if (indexFromClick == index) {
                return {
                    ...item, selected_state: !item.selected_state
                }
            } else {
                return item;
            }

        })

        setArrayOfTechnicians(newArray)

    }

    const filterSelectedTechnicians = () => {

        let filteredArray = arrayOfTechnicians.filter((item) => {
            return item.selected_state == true
        })
        clickedOnSaveButton(filteredArray);
    }

    const getTechnicianList = () => {

        setIsCallingApiGetTechnicianList(true);

        axios.get(`${process.env.REACT_APP_BACK_END_BASE_URL}/Search_Customer/technicianlist/a`).then((res) => {
  
            setIsCallingApiGetTechnicianList(false);
        
            console.log(" res is ", res);
            let newArrayAfterAddingCheckbox = res.data.jsont.map((item) => {
                return { ...item, selected_state: false }
            })
            setArrayOfTechnicians(newArrayAfterAddingCheckbox);
        }).catch(err => {
            console.log("err is ", err)
        })
    }

    useEffect(() => {
        getTechnicianList()
    }, [])

    return (
        <div className="Technician_list_popup_outer_container">
            <label>Technician list</label>

            {isCallingApiGetTechnicianList && <div className="CustomerDetailsPage-searching-loader-text-div">
                <span className="CustomerDetailsPage_search_span">
                    Loading...</span>
            </div>}

            <div className="mt-3 Technician-list-vertical">
                {
                    arrayOfTechnicians != null ?
                        arrayOfTechnicians.map((item, index) => {
                            return (
                                <div>
                                    <label className="Technician_name_clickable_label mt-1" onClick={() => changeToggleStatusOfTechnicianList(index)} ><img className="Technician-list-popup-checkbox" src={item.selected_state ? ic_checked : ic_unchecked} /> {item.Technician}</label>
                                </div>
                            )
                        })
                        :
                        null
                }
            </div>
            <div className="mt-3">
                <button className="common_close_button ms-4" onClick={clickedOnCloseButton}>Close</button>
                <button className="common_grey_button ms-4" onClick={filterSelectedTechnicians}>Save</button>

            </div>
        </div>
    )
}

export default Technician_list_popup;